import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cls from 'classnames'
import { useNav } from '../../../App';
import './index.scss'

export default function Header() {
    const { navData } = useNav();
    const { pathname } = useLocation()
    const [open, setOpen] = useState(false);
    const [isPhone, setisPhone] = useState(false); //是否是手机

    let i = navigator.userAgent.toLowerCase();

    useEffect(() => {
        if (/iphone|ipad|android|BlackBerry/.test(i)) {
            setisPhone(true);
        }
    }, [i]);
    return (
        <div className='header'>
            <Link to="/DigitalResourceLibrary/Home" className="logo"></Link>

            {isPhone ? <div className={cls("nav", { open })}>
                <div className={cls("header-menu", { open })} onClick={() => {
                    setOpen(!open)
                }}>
                    <i></i>
                </div>
                <div className="slide-menu">
                    <div className="navlist" onClick={() => {
                        setOpen(!open)
                    }}>
                        <Link to="/DigitalResourceLibrary/Home" className={cls("item", { "active": pathname === "/DigitalResourceLibrary/Home" })} >首页</Link>
                        {navData?.map((item, index) => {
                            return (
                                <Link to={`/DigitalResourceLibrary/${item.channelNo}`} className={cls("item", { "active": pathname?.includes(`/DigitalResourceLibrary/${item.channelNo}`) })} key={index} >{item.channelName}</Link>
                            )
                        })}
                    </div>
                </div>
            </div>
                : <div className="nav">
                    <Link to="/DigitalResourceLibrary/Home" className={cls("item", { "active": pathname === "/DigitalResourceLibrary/Home" })} >首页</Link>
                    {navData?.map((item, index) => {
                        return (
                            <Link to={`/DigitalResourceLibrary/${item.channelNo}`} className={cls("item", { "active": pathname?.includes(`/DigitalResourceLibrary/${item.channelNo}`) })} key={index} >{item.channelName}</Link>
                        )
                    })}
                </div>}
        </div>
    )
}
